import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { Nullable } from 'common-types';
import { FilterIssueType } from '../../../issues/common/types/issues-types';
import FiltersForm from '../../../elements/FiltersForm/FiltersForm';
import config from '../../config/applications-config.json';
import {
  appsStatisticsFirstRow,
  appsStatisticsSecondtRow,
} from '../../utils/application-utils';

const ApplicationStatistics: FC<
  React.PropsWithChildren<ApplicationStatisticsProps>
> = ({ applicationStatisticas, applicationSelected }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.applicationStatisticsContainer}>
      <div className={classes.applicationStatisticsBoxContainer}>
        {appsStatisticsFirstRow.map((stat, index) => {
          return (
            <div className={classes.applicationStatisticsBoxFirst} key={index}>
              {applicationStatisticas && applicationStatisticas[stat.type] && (
                <FiltersForm
                  filterByList={applicationStatisticas[stat.type]}
                  filterTypeToFilterBy={stat.type}
                  filterList={applicationStatisticas[stat.type]}
                  itemHeight={config.filters.itemHeight}
                  maxHeight={config.filters.maxHeightStatistics}
                  applicationSelected={applicationSelected}
                  isStatistic
                />
              )}
            </div>
          );
        })}
      </div>
      <div className={classes.applicationStatisticsSecondBoxContainer}>
        {appsStatisticsSecondtRow.map((stat, index) => {
          return (
            <div className={classes.applicationStatisticsBoxSecond} key={index}>
              {applicationStatisticas && applicationStatisticas[stat.type] && (
                <FiltersForm
                  filterByList={applicationStatisticas[stat.type]}
                  filterTypeToFilterBy={stat.type}
                  filterList={applicationStatisticas[stat.type]}
                  itemHeight={config.filters.itemHeight}
                  maxHeight={config.filters.maxHeightStatistics}
                  applicationSelected={applicationSelected}
                  isStatistic
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
const useStyles = makeStyles()((theme: Theme) => ({
  applicationStatisticsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  applicationStatisticsBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  applicationStatisticsBoxFirst: {
    minWidth: '15%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows['2'],
    margin: theme.spacing(1),
  },
  applicationStatisticsBoxSecond: {
    minWidth: '20%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows['2'],
    margin: theme.spacing(1),
  },
  applicationStatisticsSecondBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export interface ApplicationStatisticsProps {
  applicationStatisticas: Nullable<FilterIssueType>;
  applicationSelected?: string;
}

export default ApplicationStatistics;
